/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100BadRequestException } from './Ptw100BadRequestException';
import {
    Ptw100BadRequestExceptionFromJSON,
    Ptw100BadRequestExceptionFromJSONTyped,
    Ptw100BadRequestExceptionToJSON,
} from './Ptw100BadRequestException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100BadRequestException
 */
export interface ErrorResponseOfPtw100BadRequestException {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseOfPtw100BadRequestException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100BadRequestException}
     * @memberof ErrorResponseOfPtw100BadRequestException
     */
    exception: Ptw100BadRequestException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100BadRequestException
     */
    $type?: ErrorResponseOfPtw100BadRequestExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100BadRequestExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100BadRequestExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100BadRequestException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100BadRequestExceptionTypeEnum = typeof ErrorResponseOfPtw100BadRequestExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100BadRequestExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100BadRequestException interface.
 */
export function instanceOfErrorResponseOfPtw100BadRequestException(value?: unknown): value is ErrorResponseOfPtw100BadRequestException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100BadRequestExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100BadRequestExceptionFromJSON(json: any): ErrorResponseOfPtw100BadRequestException {
    return ErrorResponseOfPtw100BadRequestExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100BadRequestExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100BadRequestException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100BadRequestExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100BadRequestExceptionToJSON(value?: Omit<ErrorResponseOfPtw100BadRequestException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100BadRequestExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

